import "./footer.css";

function footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-box">
          <div className="footer-logo">
            <p className="footer-logo-title">Razor King</p>
            <p className="eyebrow footer-logo-sub">
              SETTING THE ROYAL STANDARD IN BARBERING
            </p>
          </div>

          <div className="footer-box-links">
            <h4>Business Hours</h4>
            <ul>
              <li>
                <p>Mon-Fri: 10:00AM - 8:00PM</p>
              </li>

              <li>
                <p>Sat: 10:00AM - 7:00PM</p>
              </li>

              <li>
                <p>Sun: 11:00AM - 5:00PM</p>
              </li>
            </ul>
          </div>

          <div className="footer-box-links">
            <h4>Useful</h4>
            <ul>
              <li>
                <a href="/services">Our services</a>
              </li>
              <li>
                <a href="/book-now">Book Online </a>
              </li>
              <li>
                <a href="/faq">FAQs </a>
              </li>
            </ul>
          </div>

          <div className="footer-box-links">
            <h4>Socials</h4>
            <ul>
              <li>
                <a href="https://www.instagram.com/razorking.ca">Instagram</a>
              </li>
              <li>
                <a href="/" className="inactive">
                  Tik Tok
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-box-links">
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="/">Terms & Conditions</a>
              </li>
              <li>
                <a href="/">Privacy Policy </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright @2025 Razor King Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default footer;
